import React , { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { fetchLiquidacionesListaSellers } from '../../../actions/sellersActions';
import { fetchEstadosLiquidaciones } from '../../../actions/LiquidacionesActions';
import { fetchResultadosLiquidaciones } from '../../../actions/LiquidacionesActions';
import Select from 'react-select';
import { customStyle, DropDownArrow } from '../../../template/CustomStyle';
import { toast } from 'react-toastify';
//import {  } from "../../../template/CustomStyle";
import { currencyFormat } from '../../../helper/publicacionHelper';
import { getLiquidacionesListaSellers } from '../../../api/axios';
import { getEstadosLiquidaciones } from '../../../api/axios';
import { getResultadosLiquidaciones } from '../../../api/axios.js';
import { exportToExcel } from '../../../components/General/Excel/ExcelExportHelper';

class ExportarNovedades extends Component {

    constructor(props) {
        super(props);
        this.state = {
            request: null,
            hideSpinner: true,
            estadoCheckbox: false,
            datosExcelFormateados: null,
            comboLiquidacionSeller: { label: "", value: "" },
            comboLiquidacionEstado: { label: "", value: "" },
            fechaDesde: "",
            fechaDesdePredeterminado: "",
            fechaHasta: "",
            fechaHastaPredeterminado: ""
        }
    };

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    componentDidMount() {

        let fecha = new Date();
        fecha.setDate(fecha.getDate() - 15);
        let fechaNewQuince = fecha.toISOString().slice(0, 10);
        let fechaActual = new Date();
        fechaActual.setDate(fechaActual.getDate());
        let fechaNewActual = fechaActual.toISOString().slice(0, 10);
        this.setState({
            fechaDesde: fechaNewQuince,
            fechaDesdePredeterminado: fechaNewQuince,
            fechaHasta: fechaNewActual,
            fechaHastaPredeterminado: fechaNewActual
        });

        localStorage.removeItem("ListLiquidacionesSeller");
        localStorage.removeItem("ListLiquidacionesEstado");
        localStorage.removeItem("ListLiquidacionesFechaDesde");
        localStorage.removeItem("ListLiquidacionesFechaHasta");
        localStorage.removeItem("ListLiquidacionesEliminaNovedad");
        localStorage.removeItem("ListLiquidacionesOrdenDeReferencia");
        localStorage.setItem('ListLiquidacionesEstado', 1);
        this.props.fetchLiquidacionesListaSellers();
        this.props.fetchEstadosLiquidaciones();
    }

    onChangePayMount = (event) => {

        let publicacion = "";
        let isMoney = (event.target.name == "id_a_editar_importe") ? true : false;

        if (isMoney) {
            publicacion = currencyFormat(event.target.value);
        } else {
            publicacion = event.target.value;
        }
        if (publicacion == "NaN") {
            publicacion = "";
        }

        this.setState({ inputValue: publicacion });
    }

    busquedaParaDescargarExcel = () => {

        if (this.state.estadoCheckbox === true) {

            this.setState({hideSpinner: false});
            const listaOrdenesExcel = [];
    
            if (document.getElementById("ListLiquidacionesFechaDesde").value == "") {
                toast.error("Debe seleccionar una fecha inicial");
                return;
            }
            if (document.getElementById("ListLiquidacionesFechaHasta").value == "") {
                toast.error("Debe seleccionar una fecha final");
                return;
            }
          
            localStorage.setItem('ListLiquidacionesFechaDesde', document.getElementById("ListLiquidacionesFechaDesde").value);
            localStorage.setItem('ListLiquidacionesFechaHasta', document.getElementById("ListLiquidacionesFechaHasta").value);
            localStorage.setItem('ListLiquidacionesBuscaTodo', 1);
            localStorage.setItem('ListLiquidacionesSeller', 0);
            localStorage.setItem('ListLiquidacionesEstado', 0);
            localStorage.setItem('ListLiquidacionesOrdenDeReferencia', 0);
    
            getResultadosLiquidaciones().then(res => {
    
                var objeto = res['novedades'];
            
                for (var j in objeto) {
    
                    let cargaNovedadesExcel = {
                        seller: objeto[j]['seller'],
                        fecha: objeto[j]['fechaNovedad'],
                        ordenDeReferencia: objeto[j]['ordenDeReferencia'],
                        concepto: objeto[j]['detalleTipoNovedad'],
                        estado: objeto[j]['detalleEstadoNovedad'],
                        comentarios: objeto[j]['comentarios'],
                        importe: objeto[j]['importe']
                    };
                    listaOrdenesExcel.push(cargaNovedadesExcel);
                }
    
                this.setState({
                    datosExcelFormateados: listaOrdenesExcel,
                    hideSpinner: true
                })
    
                var link = null;
                link = document.getElementById('btnDescargaExcel');
                link.click();
            });
        } 
    }

    selectSearchHandlerLiquidacionesSeller = (options) => {

        let valor = { label: options.label, value: options.value.toString() };
        this.setState({
            comboLiquidacionSeller: valor
        })
        localStorage.setItem('ListLiquidacionesSeller', options.value);

    }

    selectSearchHandlerLiquidacionesEstado = (options) => {

        let valor = { label: options.label, value: options.value.toString() };
        this.setState({
            comboLiquidacionEstado: valor
        })
        localStorage.setItem('ListLiquidacionesEstado', options.value);
    }

    mapSellers = () => {
        getLiquidacionesListaSellers().then(res => {
            let listaTipo = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            })
            this.setState({
                lista_sellers_liquidaciones: listaTipo
            })
        })
    }

    mapEstados = () => {
        getEstadosLiquidaciones().then(res => {
            let listaEstados = res.listadoEstadosNovedades.map((tipo) => {
                return { label: tipo.descripcion, value: tipo.idEstado.toString() };
            })
            this.setState({
                listaTipoEstados: listaEstados
            })
        })
    }


    render() {

        // INICIO - COMBO DE LISTA DE SELLERS
        let tipoVal = null;
        let listaTipo = [];
        if (this.props.lista_sellers_liquidaciones != undefined) {

            this.props.lista_sellers_liquidaciones.map((tipo) => {
                if (tipo.codigo == this.props.lista_sellers_liquidaciones.codigo) {
                    tipoVal = { label: tipo.descripcion, value: tipo.codigo.toString() }
                }
                listaTipo.push({ label: tipo.razonSocial, value: tipo.codigo.toString() })
            })
        }

        let selectListaSellers = 
        <div style={{
            position: "relative",
            left: "-15px",
            paddingBottom: "10px"
        }} className="col-lg-12">
            <p className="font-bold">Seller</p>
            <Select
                name="ListLiquidacionesSeller"
                id="ListLiquidacionesSeller"
                defaultValue={{ label: "Seleccione..", value: "" }}
                options={this.state.lista_sellers_liquidaciones}
                onChange={this.selectSearchHandlerLiquidacionesSeller}
                onMenuOpen={this.mapSellers}
                styles={customStyle}
                components={{ DropdownIndicator: () => DropDownArrow }}
            />
        </div>

        // INICIO - COMBO DE LISTA DE ESTADOS DE LIQUIDACIONES
        let tipoValEstados = null;
        let listaTipoEstados = [];
        if (this.props.lista_estados_liquidaciones != undefined) {
            this.props.lista_estados_liquidaciones.map((tipo, index) => {
                if (tipo.idEstado == this.props.lista_estados_liquidaciones.idEstado) {
                    tipoValEstados = { label: tipo.descripcion, value: tipo.idEstado.toString() }
                }
                listaTipoEstados.push({ label: tipo.descripcion, value: tipo.idEstado.toString() })
            })
        }

        let selectListaEstados = 
        <div style={{
            position: "relative",
            left: "-15px",
            paddingBottom: "10px"
        }} className="col-lg-12">
            <p className="font-bold">Estados</p>
            <Select
                name="ListLiquidacionesIdestado"
                id="ListLiquidacionesIdestado"
                defaultValue={{ label: "En Preparacion....", value: "1" }}
                options={this.state.listaTipoEstados}
                onChange={this.selectSearchHandlerLiquidacionesEstado}
                onMenuOpen={this.mapEstados}
                styles={customStyle}
                components={{ DropdownIndicator: () => DropDownArrow }}
            />
        </div>
        // FIN - COMBO DE LISTA DE ESTADOS DE LIQUIDACIONES

        let sizeArray = JSON.stringify(this.state.datosExcelFormateados);

        return (

            <div className="row justify-content-between page-titles">

                <div className="col-7">
                    <h4 className="text-themecolor color-rojo-megatone mx-1">Novedades</h4>
                </div>

                <div className="col-2 button-group align-self-center text-right d-none d-md-block">
                    <Spinner hidden={this.state.hideSpinner || sizeArray == "[]"} style={{ position: "relative", top: "5px", right: "0px", padding: "0px", margin: "0px" }} animation="border" variant="secondary" size="sm-centrado" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>

                <div className="col-2 button-group text-end">

                    <button type="button" onClick={this.busquedaParaDescargarExcel} className="btn btn-sm btn-green" disabled={!this.state.estadoCheckbox}>Descargar Excel</button>

                    <button 
                        id="btnDescargaExcel" 
                        type="button" 
                        hidden={true} 
                        className="btn btn-sm"
                        onClick={() => exportToExcel(this.state.datosExcelFormateados, 'Novedades', 'Novedades')}
                    >
                        Descargar Excel
                    </button>

                </div>

                <div className="card card-body filter-card m-3">
                    <div className="row form-material">

                        <div className="col-md-2">
                            <p className="font-bold">Desde</p>
                            <input 
                                type="date" 
                                name="ListLiquidacionesFechaDesde" 
                                id="ListLiquidacionesFechaDesde" 
                                className="form-control" 
                                defaultValue={this.state.fechaDesde}
                            />
                        </div>

                        <div className="col-md-2">
                            <p className="font-bold">Hasta</p>
                            <input 
                                type="date" 
                                name="ListLiquidacionesFechaHasta" 
                                id="ListLiquidacionesFechaHasta" 
                                className="form-control" 
                                defaultValue={this.state.fechaHasta}
                            />
                        </div>

                        <div className="col-3">
                            {selectListaSellers}
                        </div>

                        <div className="col-3">
                            {selectListaEstados}
                        </div>

                        <div className="col-md-2">
                            <p className="font-bold">Orden De Referencia</p>
                            <input 
                                type="number" 
                                name="ListLiquidacionesOrdenDeReferencia" id="ListLiquidacionesOrdenDeReferencia" 
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="ibox-content float-e-margins">
                        <input 
                            type="checkbox" 
                            onChange={(e) => this.setState({estadoCheckbox: e.target.checked})} 
                            id="BuscaTodo"
                        /> 
                        <label for="BuscaTodo">
                            Todas las novedades de todos los sellers en el rango de tiempo
                        </label>
                    </div>

                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones,
    tipoUsuario: state.general.tipoUsuario,
    lista_estados_liquidaciones: state.liquidaciones.lista_estados_liquidaciones,
    lista_resultado_liquidaciones: state.liquidaciones.lista_resultados_liquidaciones
});

export default connect(mapStateToProps, { 
    fetchLiquidacionesListaSellers, 
    fetchEstadosLiquidaciones, 
    fetchResultadosLiquidaciones 
}) (ExportarNovedades);